<template>
  <div>
      Zadaci
  </div>
</template>

<script>
export default {
 props: {
    accessToken: {
      type: String,
      required: true,
      default: null
    }
  },
}
</script>

<style>

</style>